import $ from 'jquery/src/jquery';
import 'jquery-validation/dist/jquery.validate.min.js';
import 'daterangepicker-4.x';
import 'daterangepicker-4.x/daterangepicker.css';
import 'jfilestyle';

$(document).ready(function($) {

    $(':file').jfilestyle({
        inputSize: '100%',
        text: '',
        placeholder: '.pdf, .doc, .docx',
    });

    if ( typeof(gform) !== 'undefined' ) {
        gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
            if ( parseInt(formId) === 1 && parseInt(fieldId) === 3 ) {
                optionsObj.minDate = 0;
            }
            return optionsObj;
        });
    }


    $('.datetimepicker input').daterangepicker({
        autoApply: true,
        autoUpdateInput: false,
        singleDatePicker: true,
        timePicker: true,
        onOutsideClick: 'cancel',
        maxDate: new Date(),
        timePicker24Hour: true,
        locale: {
            format: 'dd/MM/yyyy HH:mm'
        }
    }).val('');


    $(document).on('change', '[name="country"]', function () {
        ajaxManager.request({
            showLoader: $(this).is(':visible'),
            data: {
                action: 'get_part',
                name: 'provinces',
                country: $(this).val()
            },
            onSuccess: function (response) {
                $('[name="province"]').html(response.data.content).attr('disabled', false);
                return false;
            }
        })
    });


    formManager.initForm('.careerAlertForm');
    formManager.initForm('.careerAlertEditRequestForm');
    formManager.initForm('.careerAlertUnsubscribeRequestForm');
    formManager.initForm('.careerAlertEditRequestValidationForm');
    formManager.initForm('.volunteerForm');
    formManager.initForm('.placementForm');


    formManager.initForm('.eCardForm', {
        beforeSubmit: function (form, formData, formSettings) {
            formSettings.resetOnSuccess = formData.get('action') !== 'preview_ecard';
        },
    });


    formManager.initForm('.paymentForm', {
        ignore: ':hidden',
        resetOnSuccess: true,
        onInit: function (selector, settings) {
            const $form = $(selector);
            $form.find('select').select2({
                minimumResultsForSearch: Infinity,
                width: '100%'
            });
            $form.find('[name="organization"]').change(function () {
                const organization = $(this).val();
                $('.paymentFormSection__title').text( $(this).parents('label').text() );
                $form.find('[name="bill_type"] option').each(function (index, element) {
                    $(element).removeAttr('disabled hidden');
                    if ( !element.hasAttribute('data-' + organization ) ) {
                        $(element).attr('disabled', 'disabled').attr('hidden', 'hidden');
                    }
                });
                $form.find('[name="bill_type"]').val('').trigger('change');
                $form.find('.field[data-organization]').each(function (index, element) {
                    $(element).toggle( $(element).data('organization').includes( organization ) );
                })
            });
        }
    });


    $('.paymentForm').find('[name="bill_date"], [name="service_date"]').daterangepicker({
        autoApply: true,
        autoUpdateInput: false,
        singleDatePicker: true,
        onOutsideClick: 'cancel',
        maxDate: new Date(),
        locale: {
            format: 'd/M/yyyy'
        }
    })
        .val('')
        .on('apply.daterangepicker', function(ev, picker) {
            this.val(picker.startDate.toFormat('d/M/yyyy'));
        });


    formManager.initForm('.applicationForm', {
        ignore: ':hidden',
        ajaxSettings: {
            processData: false, // Important! Tell jQuery not to process the data
            contentType: false, // Important! Tell jQuery not to set contentType
        },
        onInit: function (selector, settings) {
            const $form = $(selector);
            $form.find('select').select2({
                minimumResultsForSearch: Infinity,
                width: '100%',
                dropdownParent: $form
            });
            $form.on('change', '[name="is_current_employee"]', function () {
                $form.find('.fieldset').show();
                $form.find('.field--internal').toggle( $(this).val() === '1' );
                $form.find('.field--external').toggle( $(this).val() === '0' );
                $form.find('.formButtons').show();
            });
            $form.on('change', '[name="current_status"]', function () {
                $form.find('[name="other_current_status"]').parents('.field').toggle( $(this).val() === 'other' );
            });
            $form.on('change', '[name="reference"]', function () {
                $form.find('[name="reference_details"]').parents('.field').toggle( $(this).val() === '7' );
            });
            $form.on('change', '[name="has_interviewed_previously"]', function () {
                $form.find('[name="interviewed_previously"]').parents('.field').toggle( $(this).val() === '1' );
            });
            $form.on('reset', function() {
               $form.find('.mainFieldset').hide();
            });
        }
    });
});